export const AUTH_STATUS = {
  loading: 'loading',
  success: 'success',
  error: 'error'
};

export const HASH_LEGALS_ALLOWED = ['#legal-policy', '#privacy-policy', '#cookies-policy'];

export const HASH_LEGALS_TO_MODALS_NAME = {
  '#legal-policy': 'legal-modal',
  '#privacy-policy': 'privacy-policy-modal',
  '#cookies-policy': 'cookie-policy-modal'
};

export const FILTERS_BY_DEFAULT = {
  showRoom: {
    filtersHasChanged: false,
    filters: {
      campaignType: {
        value: ['TODOS'],
        dataType: 'Array',
        query: 'campaignType[eqs]=#values#'
      },
      carFuelType: {
        value: [],
        dataType: 'Array',
        query: 'car.fuelType[in]=#values#'
      },
      carBrand: {
        value: '',
        dataType: 'String',
        query: 'car.brand[eqs]=#value#'
      },
      carModel: {
        value: '',
        dataType: 'String',
        query: 'car.model[eqs]=#value#'
      },
      carBodyStyle: {
        value: [],
        dataType: 'Array',
        query: 'car.bodyStyle[in]=#values#'
      },
      quoteIdQuote: {
        value: '',
        dataType: 'String',
        query: 'quote.idQuote[like]=#value#'
      },
      quoteTimeLimit: {
        value: [],
        dataType: 'Array',
        query: 'quote.timeLimit[in]=#values#'
      },
      carCO2Emission: {
        value: [],
        dataType: 'Range',
        query: 'car.cO2Emission[gte]=#value1#&car.cO2Emission[lte]=#value2#'
      },
      quoteYearKms: {
        value: [],
        dataType: 'Array',
        query: 'quote.yearKms[in]=#values#'
      },
      quotePrice: {
        value: [],
        dataType: 'Range',
        query: 'quote.price[gte]=#value1#&quote.price[lte]=#value2#'
      },
      deliveryProvinceCode: {
        value: [],
        dataType: 'Array',
        query: 'deliveryProvinceCode[in]=#values#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    }
  }
};

export const PAGE_OPTIONS = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
  { label: '200', value: 200 }
];

export const MARKETPLACE_STATE = {
  PUBLICATION: 'Publicada'
};

export const PROVINCES = {
  '01': 'Álava ',
  '02': 'Albacete ',
  '03': 'Alicante ',
  '04': 'Almería ',
  '06': 'Badajoz ',
  '07': 'Baleares ',
  '08': 'Barcelona ',
  '09': 'Burgos ',
  10: 'Cáceres ',
  11: 'Cádiz ',
  12: 'Castellón ',
  13: 'Ciudad Real ',
  14: 'Córdoba ',
  15: 'La Coruña ',
  16: 'Cuenca',
  17: 'Girona ',
  18: 'Granada ',
  19: 'Guadalajara ',
  20: 'Guipuzcoa ',
  21: 'Huelva ',
  22: 'Huesca ',
  23: 'Jaén ',
  24: 'León ',
  25: 'Lleida ',
  26: 'La Rioja ',
  27: 'Lugo',
  28: 'Madrid ',
  29: 'Málaga ',
  30: 'Murcia ',
  31: 'Navarra ',
  32: 'Orense ',
  33: 'Asturias ',
  34: 'Palencia ',
  35: 'Las Palmas de G.C. ',
  36: 'Pontevedra ',
  37: 'Salamanca ',
  38: 'Tenerife ',
  39: 'Cantabria ',
  40: 'Segovia ',
  41: 'Sevilla ',
  42: 'Soria ',
  43: 'Tarragona ',
  44: 'Teruel ',
  45: 'Toledo ',
  46: 'Valencia',
  47: 'Valladolid ',
  48: 'Vizcaya ',
  49: 'Zamora ',
  50: 'Zaragoza ',
  51: 'Ceuta ',
  52: 'Melilla '
};

export const TYPE_VEHICLE_FILTER_OPTIONS = [
  {
    value: 'TODOS',
    label: 'TODOS'
  },
  {
    value: 'NUEVO',
    label: 'NUEVO'
  },
  {
    value: 'USADO',
    label: 'USADO'
  }
];

export const KILOMETERS_FILTER_OPTIONS = [
  {
    value: '10000',
    label: '10.000 KM'
  },
  {
    value: '20000',
    label: '20.000 KM'
  },
  {
    value: '30000',
    label: '30.000 KM'
  }
];

export const TERM_FILTER_OPTIONS = [
  {
    value: '12',
    label: '12'
  },
  {
    value: '24',
    label: '24'
  },
  {
    value: '36',
    label: '36'
  },
  {
    value: '48',
    label: '48'
  }
];

export const RANGE_PRICE_OPTIONS = [0, 3000];

export const DATA_SLIDER = [300, 400, 500, 600, 700, 800, 900];

export const TYPE_FUEL_FILTER_OPTIONS = [
  {
    value: 'diesel',
    label: 'DIÉSEL'
  },
  {
    value: 'gasolina',
    label: 'GASOLINA'
  },
  {
    value: 'hibrido',
    label: 'HÍBRIDO'
  },
  {
    value: 'electrico',
    label: 'ELÉCTRICO'
  },
  {
    value: 'glp',
    label: 'GLP'
  }
];

export const RANGE_EMISSIONS_OPTIONS = [0, 250];

export const DATA_EMISSIONS_SLIDER = ['<0', '50', '100', '150', '200', '>250'];

export const TYPE_VEHICLE_DESCRIPTION = {
  ALL: 'TODOS',
  USED: 'USADO',
  NEW: 'NUEVO',
  SALE: 'VENTA'
};

export const VEHICLE_CAMPAIGN_TYPE = {
  NEW: 'NUEVO',
  ALL: 'TODOS',
  USED: 'USADO',
  SALE: 'VENTA',
  RENTING: 'ALQUILER',
  RENTINGSALE: 'ALQUILER+VENTA'
};
